import { useInboxConversation, useTellescopeMutation } from "@tellescope/tanstack-query";
import { withKey } from "@tellescope/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { pendo } from "../../../../tracking";
import { MessageCompositionFooter } from "../../../../components/MessageCompositionFooter";
import { buildHtmlMessageWithFiles } from "../../utils";

export interface InboxThreadZendeskCompositionFooterProps {
  threadId: string;
  conversationData?: ReturnType<typeof useInboxConversation>;
}

export const InboxThreadZendeskCompositionFooter = withKey(
  ({ threadId, conversationData }: InboxThreadZendeskCompositionFooterProps) => {
    const { t } = useTranslation("inbox");
    const [composerKey, setComposerKey] = useState(0);

    const internalConversationData = useInboxConversation(threadId, { enabled: !conversationData });
    const { metadata } = conversationData ?? internalConversationData;
    const enduserId = metadata?.enduserIds.at(0);
    const ticketThreadId = metadata?.threadId;

    const sendMessageMutation = useTellescopeMutation({
      model: "ticket_threads",
      method: "send_message",
      optimisticUpdates: true,
      onSuccess: () => setComposerKey((k) => k + 1),
    });

    const canSend = !!metadata && !!enduserId && !!ticketThreadId && !sendMessageMutation.isPending;

    return (
      <MessageCompositionFooter
        key={composerKey}
        editorVariant="richtext"
        channelType="zendesk"
        placeholder={t("Write a reply...")}
        canSend={canSend}
        enduserId={enduserId}
        onSubmit={({ message, files }) => {
          if (!enduserId || !ticketThreadId) return;
          pendo.track("messaging-zendesk-thread-compose-send");
          sendMessageMutation.mutate({
            enduserId,
            ticketThreadId,
            html_body: buildHtmlMessageWithFiles(message, files),
            public: true,
          });
        }}
      />
    );
  },
  "threadId"
);
